import React from "react";
import PropTypes from "prop-types";
import StyledWeightSelectorBundle from "./WeightSelectorBundle.styled";
import {replaceZero} from "../../../helpers";

const WeightSelectorBundle = React.memo(props => {
  const { className, children, onSelectProp, productId, childId, hasRadio, isLarge } = props;
  return (
    <StyledWeightSelectorBundle className={className}>
        { children && (hasRadio || children.length > 1) ?
            children.map(item=>
              <button
                className={`weight-selector__weight ${isLarge ? 't-body-medium' : 't-body'} ${childId && item.id === childId ? 'is-active' : (!childId && productId && item.id === productId) ? 'is-active' :''}`}
                key={item.id} 
                onClick={() => onSelectProp(item)}>
                  <span className={`weight-selector__radio ${childId && item.id === childId ? 'is-active' : (!childId && productId && item.id === productId) ? 'is-active' :''}`}/>
                  {item.variation && replaceZero(item.variation)}
              </button>
            )
            :
            children && children.map((item, i)=>
              <p key={i} className="weight-selector__copy t-body">{item.variation && replaceZero(item.variation)}</p>
            )  
        }
    </StyledWeightSelectorBundle>
  );
});

WeightSelectorBundle.propTypes = {
  className: PropTypes.string,
  children: PropTypes.array.isRequired,
  onSelectProp: PropTypes.func.isRequired,
  hasRadio: PropTypes.bool,
  isLarge: PropTypes.bool
};

export default WeightSelectorBundle;